import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Outlets from "../../../pages/easymerch/outlets/outlets";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const OutletsApp = () => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  return (
    <div className="App">
      <Sidebar />

      <SectionContent
        section="Easy Merch"
        title="Торговые точки"
        headBlockChildren={
          <>
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <HeaderBtn
                content="Выгрузка торговых точек"
                purpose="outletsUnload"
                modalTitle="Выгрузка торговых точек"
                hasIcon="excel"
              />
            )}
          </>
        }
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <Link to="/easymerch/outlets" className="tab">
                <div className="buttons__btn --active">Торговые точки</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <Link to="/easymerch/report" className="tab">
                <div className="buttons__btn">Типы отчетов</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <Link to="/easymerch/users" className="tab">
                <div className="buttons__btn">Физ. лица</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <Link to="/easymerch/service-types" className="tab">
                <div className="buttons__btn">Типы обслуживания</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("easy-merch:view")) && (
              <Link to="/easymerch/integration-errors" className="tab">
                <div className="buttons__btn">Ошибки интеграции</div>
              </Link>
            )}
          </div>
          <Outlets />
        </div>
      </SectionContent>
    </div>
  );
};

export default OutletsApp;
